export const BETA_MANAGER_FEATURE = 'pnr:beta-manager';
export const BETA_MANAGER_URL = '/beta/#/';
export const BETA_MANAGER_TRACKING_CLICK = {
  name: 'topnav::go-to-manager-v8-beta',
  type: 'navigation',
};
